module.exports = __webpack_public_path__ + "media/images/icn-finished-99065ff038c4b447647c7b150c9648d5.png";